module.exports = __webpack_public_path__ + "img/pJoin-banner.deea70c3.jpg";